import React, { createContext, useState, useEffect } from "react";
import Axios from "axios";
import { Host } from "../App";
import { useHistory } from "react-router-dom";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [hasReloaded, setHasReloaded] = useState(false); // Prevent infinite reloads
  const token = localStorage.getItem("acessToken"); // Read token from localStorage
  const history = useHistory();
  const login = (token) => {
    localStorage.setItem("acessToken", token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("acessToken");
    setIsAuthenticated(false);
  };

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          const response = await Axios.get(`https://${Host}/verifyToken/privateroute/token`, {
            params: { token },
          });
          setIsAuthenticated(true);
        } catch (error) {
          console.error("Error verifying token:", error);
          setIsAuthenticated(false);
          history.push("/login");
        }
      } else {
        console.warn("No token found in localStorage.");
        setIsAuthenticated(false);
        history.push("/login");
      }
    };

    // Run token verification initially
    // verifyToken();

    // Periodic verification every 30 seconds
    const interval = setInterval(() => {
      //  verifyToken();
    }, 30000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [token]);



  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
